import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { getSafeStorage } from "./storageFallback";
import { BreakItem } from "../../pages/Simulcast/components/AdSystemInfo/types";

interface BreakStore {
  breaks: BreakItem | null;
  breaksArray: BreakItem[];
  position: number;
  hasSlate: boolean;
  setBreak: (breakItem: BreakItem) => void;
  setPosition: (position: number | undefined) => void;
  getPosition: () => number;
  getBreak: () => BreakItem | null;
  setBreaksArray: (breakItems: BreakItem[]) => void;
  getBreaksArray: () => BreakItem[];
  getBreakById: (id: string) => BreakItem | undefined;
  getHasSlate: () => boolean;
  setHasSlate: (hasSlate: boolean) => void;
  clearBreaks: () => void;
}

type Persisted = Pick<BreakStore, "breaks" | "position" | "hasSlate">;

const useBreaksStore = create(
  persist<BreakStore, [], [], Persisted>(         
    (set, get) => ({
      breaks: null,
      breaksArray: [],
      position: 0,
      hasSlate: false,
      setBreak: (breakItem) => set({ breaks: breakItem }),
      setPosition: (local) => set({ position: local ?? 0 }),
      getPosition: () => get().position,
      getBreak: () => get().breaks,
      setBreaksArray: (breakItems) => set({ breaksArray: breakItems }),
      getBreaksArray: () => get().breaksArray,
      getBreakById: (id) => get().breaksArray.find(b => b.id === id),
      clearBreaks: () => set({ breaks: null, breaksArray: [] }),
      getHasSlate: () => get().hasSlate,
      setHasSlate: (hasSlate) => set({ hasSlate }),
    }),
    {
      name: "breaks-storage",
      storage: createJSONStorage(() => getSafeStorage()),
      version: 1,
      partialize: (state): Persisted => ({
        breaks: state.breaks,
        position: state.position,
        hasSlate: state.hasSlate,
      }),
    }
  )
);

export default useBreaksStore;
